import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import CardInputGoogleDrive from '../Card-Input-Google-Drive';
import { accountServices } from '../../../../constants';

const TabPaneDirectories = ({
  accountParam,
  getValues,
  gDriveFolders,
  watch,
  isAccountDeactivated,
}) => {
  const { t: translate } = useTranslation();

  return (
    <div className="d-flex gap-3 flex-wrap justify-content-between">
      {getValues('services').map((service, index) => {
        const serviceMatch = accountServices.find((s) => s.value === service.value);

        if (!serviceMatch) return null;

        const serviceLabel =
          serviceMatch.value === 'media' || serviceMatch.value === 'paidMedia'
            ? translate('PaidMedia')
            : serviceMatch.label;

        // In the business rule, there is no folder option for the Locasty service.
        if (serviceLabel === 'Locasty') return null;

        const folderKey = serviceMatch.value === 'paidMedia' ? 'media' : serviceMatch.value;

        const folder = gDriveFolders?.[folderKey]?.root || null;

        return (
          <CardInputGoogleDrive
            key={serviceMatch.value + index}
            accountId={accountParam}
            accountName={watch('name')}
            service={serviceMatch.value}
            label={serviceLabel}
            folderLink={folder}
            disabled={isAccountDeactivated}
          />
        );
      })}
    </div>
  );
};

TabPaneDirectories.propTypes = {
  accountParam: PropTypes.string,
  getValues: PropTypes.func.isRequired,
  gDriveFolders: PropTypes.object.isRequired,
  watch: PropTypes.func.isRequired,
  isAccountDeactivated: PropTypes.bool.isRequired,
};

export default TabPaneDirectories;
